<template lang="pug">
	a(@click="openPreview()") {{ params.data.name }}
</template>

<script>
import Vue from 'vue'
import { EventBus } from '@/common/event-bus.js'

export default Vue.extend({
	name: 'ag-grid-preview-project',
	data () {
		return {
			isPreview: null,
			popUpPreview: ''
		}
	},
	created () {
		this.isPreview = this.params.data
	},
	methods: {
		openPreview () {
			this.popUpPreview = 'projects'
			EventBus.$emit('is-pop-up-on', this.isPreview, this.popUpPreview)
		}
	}
})
</script>



// WEBPACK FOOTER //
// src/app/project/ag-grid/preview-project.vue